module.exports = __webpack_public_path__ + "img/Noticeboard.af0cb614.png";